import { ReactNode } from "react";
import { useEditor, useNode } from "@craftjs/core";
import { CssClass } from "../settings/ClassSettings";
import EmptyState from "@/components/EmptyState";
import useResponsiveValues from "../hooks/useResponsiveValues";

interface Props extends CssClass {
  children: ReactNode;
}

const ElementBlock = (props: Partial<Props>) => {
  const {
    id,
    connectors: { connect, drag },
  } = useNode();
  const responsive = useResponsiveValues();

  const { isEmpty } = useEditor((_, query) => ({
    isEmpty: !query.node(id).childNodes().length,
  }));

  return (
    <div ref={(ref: any) => connect(drag(ref))} className={`element ${responsive.getValue(props?.cssClass)}`} key={`${id}-${responsive.viewport}`}>
      {isEmpty ? <EmptyState /> : props?.children}
    </div>
  );
};

ElementBlock.craft = {
  displayName: "Elementos",
  props: {},
  rules: {
    canDrag: () => true,
    canDrop: () => true,
  },
  related: {
    // settings:
  },
};

export default ElementBlock;
